import { Box } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

/**
 * In the top right corner of a container
 * Sets the containerFloat topology
 */
const ContainerFloat: FC<PropsWithChildren<{ floatResponsive?: boolean }>> = ({ children, floatResponsive }) => {
  return (
    <Box
      sx={{
        alignItems: { xs: floatResponsive ? 'start' : 'center', sm: 'center' },
        display: 'flex',
        gap: { xs: '0.5rem', md: '1rem' },
        flexDirection: { xs: floatResponsive ? 'column' : 'row', sm: 'row' },
        width: floatResponsive ? '100%' : undefined,
        justifyContent: { xs: floatResponsive ? 'space-between' : 'end', md: 'end' },
      }}
    >
      {children}
    </Box>
  );
};

export default ContainerFloat;
